import Vue from 'vue'

export default {
    namespaced: true,
    state: {
        solarProductivity: 0,
        electricMeter: 0,
        electricMeter2: 0,
        electricMeter3: 0,
        /////////////////////
        propaneMeter: 0,
        gasMeter: 0,
        /////////////////////
        wineryProcess: 0,
        tastingOffices: 0,
        landscaping: 0,
        /////////////////////
        nitrogenId: '',
        nitrogenSolid: 0,
        nitrogenLiquid: 0,
        nitrogenCompost: 0,
        nitrogenManure: 0,
    },
    getters: {
        nitrogenSolid: state => state.nitrogenSolid,
        nitrogenLiquid: state => state.nitrogenLiquid,
        nitrogenCompost: state => state.nitrogenCompost,
        nitrogenManure: state => state.nitrogenManure,
        solarProductivity(state) {
            return state.solarProductivity;
        },
        electricMeter(state) {
            return state.electricMeter;
        },
        electricMeter2(state) {
            return state.electricMeter2;
        },
        electricMeter3(state) {
            return state.electricMeter3;
        },
        wineryProcess(state) {
            return state.wineryProcess;
        },
        tastingOffices(state) {
            return state.tastingOffices;
        },
        landscaping(state) {
            return state.landscaping
        }
    },
    mutations: {
        solarProductivity(state, payload) {
            return state.solarProductivity = payload;
        },
        electricMeter(state, payload) {
            return state.electricMeter = payload;
        },
        electricMeter2(state, payload) {
            return state.electricMeter2 = payload;
        },
        electricMeter3(state, payload) {
            return state.electricMeter3 = payload;
        },
        wineryProcess(state, payload) {
            state.wineryProcess = payload;
        },
        tastingOffices(state, payload) {
            state.tastingOffices = payload;
        },
        landscaping(state, payload) {
            state.landscaping = payload;
        },
        nitrogenId(state, payload) {
            state.nitrogenId = payload
        },
        nitrogenSolid(state, payload) {
            state.nitrogenSolid = payload
        },
        nitrogenLiquid(state, payload) {
            state.nitrogenLiquid = payload
        },
        nitrogenCompost(state, payload) {
            state.nitrogenCompost = payload
        },
        nitrogenManure(state, payload) {
            state.nitrogenManure = payload
        },
        calcAndUpdateWineryPowerData(state, powerData) {
            let solarProductivityAdder = 0;
            let electricMeterAdder = 0;
            let electricMeter2Adder = 0;
            let electricMeter3Adder = 0;
            powerData.months.forEach(data => {
                solarProductivityAdder += data.solarProductivity;
                electricMeterAdder += data.electricMeter;
                electricMeter2Adder += data.electricMeter2;
                electricMeter3Adder += data.electricMeter3;
            });
            state.solarProductivity = solarProductivityAdder;
            state.electricMeter = electricMeterAdder;
            state.electricMeter2 = electricMeter2Adder;
            state.electricMeter3 = electricMeter3Adder;
            console.log(`Solar value: ${solarProductivityAdder}`);
        },
        calcAndUpdateWineryGasData(state, fertilizerData) {
            let gasAdder = 0;
            let propaneAdder = 0;
            fertilizerData.months.forEach(data => {
                gasAdder += data.gasMeter;
                propaneAdder += data.propaneMeter;
            });

            state.gasMeter = gasAdder;
            state.propaneMeter = propaneAdder;
            console.log(`Vuex Winery Natural gas: ${gasAdder}`);
            console.log(`Vuex Winery propane: ${state.propaneMeter}`);
        },
        calcAndUpdateWineryWaterData(state, waterData) {
            let wineryProcess = 0;
            let tastingOffices = 0;
            let landscaping = 0;
            waterData.months.forEach(data => {
                tastingOffices += data.tastingOffices;
                wineryProcess += data.wineryProcess;
                landscaping += data.landscaping;

            });

            state.tastingOffices = tastingOffices;
            state.wineryProcess = wineryProcess;
            state.landscaping = landscaping;
            console.log(`Vuex Tasting Offices: ${state.tastingOffices}`);
            console.log(`Vuex Landscaping: ${state.landscaping}`);
        },
    },
    actions: {
        loadNitrogenData({commit}, {groupId, year}) {
            return Vue.prototype.$http
                .get(`metrics/production/nitrogen/vineyard/${groupId}/${year}`)
                .then(result => {
                    if (result.data !== null) {
                        commit('nitrogenId', result.data._id)
                        commit('nitrogenSolid', result.data.solid)
                        commit('nitrogenLiquid', result.data.liquid)
                        commit('nitrogenCompost', result.data.compost)
                        commit('nitrogenManure', result.data.manure)
                    }
                })
        },
        uploadNitrogenData({state, commit}, {groupId, year}) {
            const nitrogen = {
                solid: state.nitrogenSolid,
                liquid: state.nitrogenLiquid,
                compost: state.nitrogenCompost,
                manure: state.nitrogenManure,
                year,
                groupId,
                _id: state.nitrogenId
            }
            return Vue.prototype.$http
                .post(
                    `metrics/production/nitrogen/vineyard/${groupId}`,
                    JSON.stringify(nitrogen, null, 3),
                    {headers: {'content-type': 'application/json'}}
                )
                .then(response => {
                    if (!state.nitrogenId) {
                        commit('nitrogenId', response.data._id)
                    }
                })
        }
    }
}
